import { all, takeEvery } from 'redux-saga/effects';
import logListActions from './actions';
import Api from '../../../../helpers/api';
import { getLoadData } from '../../../../components/logs/saga';

const api = new Api('jobs/:id/logs');

/*
  Leaving this for futere reference (How to set groups with different action types)
  const sections = [
    { name: 'Group A', actions: ['skills_add', 'edit_hired_date', 'accreditation_submission_edited'] },
    { name: 'Group B', actions: ['active'] },
    { name: 'Group C', actions: ['promote_failed', 'status_changed'] },
  ];
*/

const sections = [];
const loadData = getLoadData(logListActions, api, sections);

export default function* rootSaga() {
  yield all([takeEvery(logListActions.LOAD, loadData)]);
}
